import axios from 'axios';
import env from '../Utils/env';
import localStorage from "redux-persist/lib/storage";


// Crée une instance Axios
const api = axios.create({
  baseURL: env.baseURL, 
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(async (config) => {
  const token = await localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

//add new user 
export const createUser = async (userData) => {
    
  return await api.post('/add-user', userData);
};

export const getUsers = async () => {
    
  return api.get('/all-users');

};

export const deleteUser = async (id) => {
  return api.delete(`/delete-user/${id}`)
};

export const updatedUser = async (data) => {
  return await api.put(`/update-user`, data);
};